import { useMemo } from "react";
import { useMuscleCoverage, useTodayAnyway, type TodayEmptyHost } from "@heraion/ui";

import { useSelfAthleteTargets } from "./progress/useSelfAthleteTargets";
import { useSelfProgressDeps } from "./progress/progressDeps";
import { useProfileDoc } from "./useProfileDoc";
import { useWorkoutStarter } from "./useWorkoutStarter";

const noop = () => {};

// What the empty «today» draft card needs from this screen (D-c): «Build one
// anyway» and the weekly-minimum fact, both read off the coverage the create
// hub reads (same targets, so the same gaps). The starter is only held, never
// handed to the shell: the open logger swaps the draft in place. Twin of
// apps/mobile/src/screens/useTodayEmptyHost.ts.
export function useTodayEmptyHostWeb(): TodayEmptyHost {
  const base = useSelfProgressDeps();
  const { value: athleteTargets } = useSelfAthleteTargets();
  const deps = useMemo(() => ({ ...base, athleteTargets }), [base, athleteTargets]);
  const { coverage, catalog } = useMuscleCoverage(deps);
  const { doc } = useProfileDoc();
  const rawBodyweight = doc?.["bodyweightKg"];
  const bodyweightKg = typeof rawBodyweight === "number" ? rawBodyweight : null;
  // null: a built «today» draft carries its own catalog (catalogItems).
  const { buildTodayStarter } = useWorkoutStarter(null, bodyweightKg, noop);
  return useTodayAnyway({ coverage, catalog, painMap: deps.painMap, buildTodayStarter });
}
